var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33333 17.3325C7.12212 17.544 6.87128 17.7118 6.59517 17.8263C6.31906 17.9409 6.02309 17.9999 5.72417 18H2.5V14.7966C2.5 14.1933 2.74 13.6141 3.16667 13.1875M7.33333 17.3325L3.16667 13.1875M7.33333 17.3325L15.645 9.01746M3.16667 13.1875L11.4867 4.8583L12.675 3.6683C12.8865 3.45651 13.1376 3.28848 13.414 3.17381C13.6905 3.05914 13.9868 3.00008 14.2861 3C14.5854 2.99992 14.8817 3.05883 15.1582 3.17336C15.4347 3.28789 15.6859 3.45579 15.8975 3.66746L16.8358 4.60663C17.2629 5.03374 17.5029 5.61302 17.5029 6.21705C17.5029 6.82107 17.2629 7.40035 16.8358 7.82746L15.645 9.01746M15.645 9.01746L11.4858 4.8583",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.8c6f9db2044ea3c4d899657e62f4c717.svg";
export { ForwardRef as ReactComponent };